<template>
  <div v-on-clickaway="onClickOutside" class="min-w-160 inline-block relative text-left">
    <div>
      <span class="rounded-md shadow-sm">
        <button id="options-menu"
                type="button"
                class="inline-flex items-center justify-between w-full bg-white text-xs py-3 px-4 shadow-button"
                aria-haspopup="true"
                aria-expanded="true"
                @click="onDropdownToggle"
        >
          <div :class="{ 'font-bold': activeCategoriesCount > 0 }">
            <span>{{ category.name }}</span>
            <span v-if="activeCategoriesCount > 0">&nbsp;({{ activeCategoriesCount }})</span>
          </div>
          <span class="icon-chevron-down text-3xs ltr:ml-4 rtl:mr-4" />
        </button>
      </span>
    </div>

    <transition enter-active-class="transition-all duration-300 ease-out"
                leave-active-class="transition-all duration-300 ease-out"
                enter-class="opacity-0 invisible"
                enter-to-class="opacity-100 visible"
                leave-class="opacity-100 visible"
                leave-to-class="opacity-0 invisible"
    >
      <div v-if="isShowDropdown" class="origin-top-right absolute left-0 w-full bg-white shadow-dropdown mt-1 z-10">
        <div class="max-h-260 overflow-y-auto text-2xs p-1"
             role="menu"
             aria-orientation="vertical"
             aria-labelledby="options-menu"
        >
          <template v-if="showAsLinks">
            <a v-for="(childCategory, index) in categoriesFiltered"
               :key="childCategory.slug"
               :href="childCategory.url"
               class="disabled:opacity-30 disabled:cursor-default flex items-center justify-between w-full text-left border border-beige py-1 px-2 mb-1 transition-colors duration-300 hover:bg-primary-light"
               :class="{ 'bg-primary-light': childCategory.active, 'last:mb-0': index == categoriesFiltered.length - 1 }"
               role="menuitem"
               @click.prevent="onChangeCategory(childCategory)"
            >
              <span>{{ getChildCategoryName(childCategory) }}</span>
              <span v-if="childCategory.active" class="icon-check ltr:ml-2 rtl:mr-2" />
            </a>
          </template>
          <template v-else>
            <button v-for="(childCategory, index) in categoriesFiltered"
                    :key="childCategory.slug"
                    class="disabled:opacity-30 disabled:cursor-default flex items-center justify-between w-full text-left border border-beige py-1 px-2 mb-1 transition-colors duration-300 hover:bg-primary-light"
                    :class="{ 'bg-primary-light': childCategory.active, 'last:mb-0': index == categoriesFiltered.length - 1 }"
                    role="menuitem"
                    @click="onChangeCategory(childCategory)"
            >
              <span>{{ getChildCategoryName(childCategory) }}</span>
              <span v-if="childCategory.active" class="icon-check ltr:ml-2 rtl:mr-2" />
            </button>
          </template>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway'
import { computed, watch, ref } from 'vue'

import searchFactory from '@/compositions/search/SearchFactory'
import searchQueryState from '@/compositions/search/SearchQuery'

export default {
  mixins: [clickaway],
  props: {
    category: {
      type: Object,
      required: true
    },
    showAsLinks: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup(props) {
    const isShowDropdown = ref(false)
    const activeCategoriesCount = ref(0)

    const {
      addCategory,
      removeCategory,
      searchQuery
    } = searchQueryState.searchQueryUse()
    const { termsFacet } = searchFactory.useSearchResult()

    const categoriesFiltered = computed(() => {
      const groups = []

      props.category.categories.forEach((childCategory) => {
        let filteredTerms = []
        if (termsFacet.value) {
          filteredTerms = termsFacet.value.filter((term) => term.term == childCategory.name)
        }
        const newGroup = { ...childCategory }

        if (filteredTerms && filteredTerms.length > 0) {
          newGroup.hasItems = true
          newGroup.itemsCount = filteredTerms[0].count
        } else {
          newGroup.hasItems = false
          newGroup.itemsCount = 0
        }

        newGroup.active = searchQuery.activeCategories
          && searchQuery.activeCategories.length > 0
          && searchQuery.activeCategories.includes(newGroup.name)

        groups.push(newGroup)
      })

      return groups
    })

    watch(categoriesFiltered, (categories) => {
      activeCategoriesCount.value = categories.filter((cat) => cat.active).length
    })

    function onChangeCategory(category) {
      if (!category.active) {
        addCategory(category.name)
      } else {
        removeCategory(category.name)
      }
    }

    function getChildCategoryName(childCategory) {
      const categoryName = childCategory.name.split('_')[1]
      if (childCategory.itemsCount < 1) {
        return categoryName
      }
      return categoryName.concat(' (', childCategory.itemsCount, ') ')
    }

    function onDropdownToggle() {
      isShowDropdown.value = !isShowDropdown.value
    }
    function onClickOutside() {
      isShowDropdown.value = false
    }

    return {
      categoriesFiltered,
      activeCategoriesCount,
      isShowDropdown,
      getChildCategoryName,
      onDropdownToggle,
      onClickOutside,
      onChangeCategory
    }
  }
}
</script>
